import * as React from "react";

const IconListsUser: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="currentColor"><path fill="currentColor" d="M5.24999973,6 C6.32179642,6 7.31217813,5.42820311 7.84807634,4.5 C8.38397455,3.57179689 8.38397455,2.42820311 7.84807634,1.5 C7.31217813,0.571796894 6.32179642,0 5.24999973,0 C4.17820323,0 3.18782222,0.571796894 2.65192366,1.5 C2.11602509,2.42820311 2.11602509,3.57179689 2.65192366,4.5 C3.18782222,5.42820311 4.17820323,6 5.24999973,6 Z M10.5,12 L9,7.125 L1.5,7.125 L0,12 L10.5,12 Z" transform="translate(0 .5)"/></svg>;
};

export default React.memo(IconListsUser);
